<template>
    <div class="form-vacancy" v-if="formsData != null">
        <form class="form-call-vacancy" v-if="formVisible">
            <div class="form-in" :class="{fadeOut : !formVisible}">
                <div class="form-group form-text" :class="{'error' : errors.has('name')}">
                    <label for="name">{{ formsData.form_vacancy.name_label }}</label>
                    <input type="text" name="name" class="form-control" :placeholder="formsData.form_vacancy.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone" :class="{'error' : errors.has('phone')}">
                    <label for="phone">{{ formsData.form_vacancy.phone_label }}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="form-group form-text" :class="{'error' : errors.has('email')}">
                    <label for="email">{{ formsData.form_vacancy.email_label }}</label>
                    <input type="text" name="email" class="form-control" :placeholder="formsData.form_vacancy.email_mask" v-model="email" v-validate="{ required: true, regex: regexRules.email }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-upload" :class="{'error' : vac_file == null}">
                    <label>{{ formsData.form_vacancy.resume_label }}</label>
                    <div class="fileUpload" v-if="this.vac_file == null">
                        <span>{{formsData.form_vacancy.resume_mask}}</span>
                        <input type="file" multiple 
                            accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf,.zip,.rar,.7zip"
                            @change="FileUpload($event)"
                        >
                        <svgIcon name="attach" class="icon-attach"/>
                    </div>
                    <div class="uploadComplete" v-else>
                        <span>Файл добавлен</span>
                    </div>
                </div>
                <div class="form-textarea" :class="{'error' : errors.has('textarea')}">
                    <label>{{ formsData.form_vacancy.comment_label }}</label>
                    <textarea class="form-control textarea-control" name="textarea" type="text" cols="50" rows="8" v-model="coomment" :placeholder="formsData.form_vacancy.comment_mask" v-validate="{ required: true, regex: regexRules.msg }"  data-vv-delay="1000"/>
                </div>
                <div class="form-agree-politics">
                    <div class="form-check-elem">
                        <input type="checkbox" id="vacancyform-check-elem" v-model="politics_agree"> 
                        <label for="vacancyform-check-elem" v-if="globalLang != 'kz/'">{{formsData.form_vacancy.btn_agree.def}} <router-link to="/data-policy">{{ formsData.form_vacancy.btn_agree.link }}</router-link></label>
                        <label for="vacancyform-check-elem" v-else><router-link to="/data-policy">{{ formsData.form_vacancy.btn_agree.link }}</router-link> {{formsData.form_vacancy.btn_agree.def}}</label>
                    </div>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">
                        <span>{{formsData.form_vacancy.btn_send}}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                    <div class="anounce"><p>{{ formsData.form_vacancy.anounce }}</p></div>
                </div>
                <div class="form-error-msg" v-if="errorAgreePolitics || errorMsgFile || errorMsg">
                    <p v-if="errorMsgFile">Загрузите файл</p>
                    <p v-if="errorAgreePolitics">Вы не приняли политику обработки данных</p>
                    <p v-if="errorMsg">Заполните все поля</p>
                </div>
            </div>
        </form>
        <div class="successMessage-vacancyform" v-if="!formVisible">
            <h3 v-html="formsData.form_vacancy.complete_msg"></h3>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'formAboutVacancy',
        data () {
            return {
                globalLang: window.GlobalLang, 
                name: '',
                phone: '',
                coomment: '',
                email: '',
                politics_agree: false,

                admin_mail: '',
                formVisible: true,
                errorMsg: false,
                errorMsgFile: false,
                errorAgreePolitics: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/,
                    msg: /^([а-яА-ЯёЁa-zA-Z0-9_\.\+-].*[\s\.]*){1,500}$/
                },
                vac_file: null,
                typeFile: null,
                sizeFile: null,
            }
        },
        components: {
            MaskedInput,
            svgIcon,
        },
        computed: mapGetters({
            formsData: 'loadFormsData',
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var urlForm = window.mainUrl + '/server/form-vacancy.php';
                var dataForm = {
                    'admin': this.formsData.form_vacancy.admin_email_vacancy,
                    'name': this.name,
                    'phone': this.phone,
                    'email': this.email,
                    'file_link' : null,
                    'comment': this.coomment,
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.errorMsg = false;
                        if (this.vac_file != null) {
                            this.errorMsgFile = false;
                            if (this.politics_agree) {
                                this.errorAgreePolitics = false;
                                this.formVisible = false
                                var formData = new FormData();
                                formData.append('file', this.vac_file);
                                axios.post(window.mainUrl + '/server/upload-vac.php', formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }).then((response) => {
                                    // console.log(response);
                                    dataForm.file_link = window.mainUrl + '/uploads/' + response.data;
                                    axios.post(urlForm, querystring.stringify(dataForm)).then((response) => {
                                        window.dataLayer.push({'event' : 'form_start'});
                                    });
                                    $.ajax({
                                        url: "https://docs.google.com/forms/d/e/1FAIpQLSf8Zea-2Ca8BmWO9JmLR8tE5oLKIGqA-63pOdVaZUvo4-N_bg/formResponse",
                                        data: {
                                            "entry.2032026928" : dataForm.name,
                                            "entry.1911004569" : dataForm.phone,
                                            "entry.348967540": dataForm.email,
                                            "entry.423013913": dataForm.comment,
                                            "entry.642622357": dataForm.file_link,
                                        },
                                        type: "GET",
                                        dataType: "xml"
                                    });
                                    // console.log(dataForm, 'DATA FORM VACANCY');
                                }).catch((error) => {
                                    console.log(error, 'file upload on server error');
                                })
                            } else {
                                this.errorAgreePolitics = true;
                                console.log('Data policy is not agree');
                            }
                        } else {
                            this.errorMsgFile = true;
                            console.log('Form file is not uploaded');
                        }
                      
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            FileUpload(event) {
                this.vac_file = event.target.files[0];
                // this.typeFile = this.vac_file.name.match(/\.[0-9a-z]+$/i)[0];
                // this.sizeFile = this.vac_file.size;
                // console.log(event.target.files[0], 'SAVE FILE')
            },
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-vacancy.scss';
    @import '@/styles/components/forms/respond/form-vacancy-respond.scss';
</style>